import { useEffect, useState } from 'react';
import type { ModelPickerValue } from '@/components/ModelPicker';
import { settingsService, AiModelsResponse } from '@/services/settings.service';

export function TiktokModelPicker({ value, onChange }: { value?: ModelPickerValue; onChange: (value: ModelPickerValue) => void }) {
  const [models, setModels] = useState<AiModelsResponse | null>(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let alive = true;
    setFailed(false);
    settingsService.listAiModels().then((result) => { if (alive) setModels(result); }).catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [attempt]);
  if (failed) return <button type="button" className="text-xs text-text-muted underline" onClick={() => setAttempt((n) => n + 1)}>Reload AI models</button>;
  return <select aria-label="AI model" disabled={!models} value={value ? `${value.provider}:${value.model}` : models ? `${models.default.provider}:${models.default.model}` : ''}
    className="h-8 max-w-[200px] rounded-lg border border-border bg-surface px-2 text-xs text-text-primary"
    onChange={(e) => {
      for (const provider of models?.providers ?? []) {
        const model = provider.models.find((m) => `${provider.id}:${m.id}` === e.target.value);
        if (model) { onChange({ provider: provider.id, model: model.id }); return; }
      }
    }}>
    {!models ? <option value="">Loading models…</option> : models.providers.filter((p) => p.available).map((p) => <optgroup key={p.id} label={p.label}>{p.models.map((m) => <option key={m.id} value={`${p.id}:${m.id}`} disabled={m.deprecated}>{m.label}</option>)}</optgroup>)}
  </select>;
}
